import {
    ReactInstance,
    MouseInputChannel,
    TouchInputChannel,
    InputChannel,
    GamepadInputChannel,
} from 'virtual-tour-viewer/src/modules/React360Proxy';

import EventLayerKeyboardInputChannel from '../InputChannels/EventLayerKeyboardInputChannel';

export default class InputChannelDirector {
    _reactInstance: ReactInstance;
    _mouseInputChannel: InputChannel;
    _touchInputChannel: InputChannel;
    _keyboardInputChannel: InputChannel;
    _gamepadInputChannel: InputChannel;

    constructor(reactInstance: ReactInstance) {
        this._reactInstance = reactInstance;
        this._mouseInputChannel = new MouseInputChannel(this._reactInstance._eventLayer);
        this._touchInputChannel = new TouchInputChannel(this._reactInstance._eventLayer);
        this._keyboardInputChannel = new EventLayerKeyboardInputChannel(
            this._reactInstance._eventLayer
        );
        this._gamepadInputChannel = new GamepadInputChannel();
        this._reactInstance.controls.clearEventChannels();
        this._reactInstance.controls.addEventChannel(this._mouseInputChannel);
        this._reactInstance.controls.addEventChannel(this._touchInputChannel);
        this._reactInstance.controls.addEventChannel(this._keyboardInputChannel);
        this._reactInstance.controls.addEventChannel(this._gamepadInputChannel);
    }
}
